export default __webpack_public_path__ + "static/media/paraguay_flag.8c303bba.svg";